import React from "react";
import ContractAndPaymentTerms from "./ContractAndPaymentTermsOverview";
import ProjectDetailsOverview from "./ProjectDetailsoverview";
import CompanyInformation from "./CompanyInformationOverview";
import { DataNotFound } from "../../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";
import ContactInformationOverview from "../CompanyProfileOverview/ContactInformationOverview";
import AccountAndInformationOverview from "../CompanyProfileOverview/AccountAndInformationOverview";

const ProjectInformationOverview = ({ data, type = "debit" }) => {
  if (!data) return <DataNotFound />;
  return (
    <React.Fragment>
      <ProjectDetailsOverview data={data} type={type} />
      <ContractAndPaymentTerms data={data} type={type} />
      <CompanyInformation data={data} type={type} />
      <ContactInformationOverview data={data} type={type} />
      <AccountAndInformationOverview data={data} type={type} />
    </React.Fragment>
  );
};
export default ProjectInformationOverview;
